import { ComponentPropsWithoutRef, FormEvent } from 'react';
import {
  FieldValues,
  UseFormReturn,
  SubmitHandler,
  FormProvider,
} from 'react-hook-form';

interface SUFormProps<T extends FieldValues>
  extends Omit<ComponentPropsWithoutRef<'form'>, 'onSubmit'> {
  form: UseFormReturn<T>;
  children: any;
  onSubmit?: SubmitHandler<T>;
}

const RHFForm = <T extends FieldValues>({
  form,
  children,
  onSubmit,
  ...props
}: SUFormProps<T>) => {
  const { handleSubmit } = form;
  const handleFormSubmit = onSubmit
    ? handleSubmit(onSubmit, (error) => console.log(error))
    : (e: FormEvent<HTMLFormElement>) => e.preventDefault();

  return (
    <FormProvider {...form}>
      <form {...props} onSubmit={handleFormSubmit}>
        <fieldset>{children}</fieldset>
      </form>
    </FormProvider>
  );
};

export default RHFForm;
